import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAutionMineOrderList } from "../../../../redux/auction/action";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import ActionStatusLabel from "../../../Common/Label/ActionStatusLabel";

export default function AuctionItems() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();
  const auctionlist = useSelector(
    ({ auction: { autionmineorderlist } }) => autionmineorderlist
  );

  useEffect(() => {
    dispatch(getAutionMineOrderList(3));
  }, []);

  return (
    <>

      {Array.isArray(auctionlist) && auctionlist?.length > 0 ?
        <div className="project-section auction-order">
          <div className="tab-sec">
            <div className="filter-right ">
              {/* <h2>Auctions orders</h2> */}
              <div className="row auction-row">
                <>
                  {auctionlist.map((item, index) => (
                    <div className="col-md-4" onClick={() => { navigate(`/${lan}/dashboard/myorders/actionorderdetails/${item?.id}`) }}>
                      <div className="auction-det">
                        <img src={Array.isArray(item?.files) && item?.files && item.files[0].file} className="w-100 auction-img" alt="" />
                        <h4>{item?.title}</h4>
                        <div className="minimum-bid">
                          <div>
                            <p>Minimum bid</p>
                            <h6>$ {Commas(item?.min_bid)}</h6>
                          </div>
                          {item?.auction_type == 2 &&
                            <div>
                              <h5><img src={`${CloudStorage.cloudurl}/Assets/Images/common/hand-tick.svg`} alt="" />{item?.bid_count}</h5>
                            </div>
                          }
                        </div>
                        {item?.winning_bid?.id && (
                          <p className="end-in">
                            Winning bid : $ {Commas(item?.winning_bid?.price)}
                            <span>
                              {
                                item?.winning_bid?.is_mine == 1 ? <></> :
                                  <>
                                    <ProfileImageWithFallback url={item?.winning_bid?.profile_image} />
                                    @{`${item?.winning_bid?.first_name} ${item?.winning_bid?.last_name}`} won the auction
                                  </>}
                            </span>
                          </p>
                        )}
                        {item?.winning_bid?.id &&
                          <div style={{ paddingTop: 5 }}>
                            {item?.winning_bid?.is_mine == 1 ? (
                              <p className="end-in">
                                <span>
                                  🎉 You won the auction
                                </span>
                              </p>
                            ) : (
                              <></>
                              // <p className="end-in" style={{ background: item?.winning_bid?.is_mine == 1 ? '' : '#ddd' }}>
                              //   <span>
                              //     You lost the auction
                              //   </span>
                              // </p>
                            )}
                          </div>}
                        {item?.winning_bid?.id ? "" : <ActionStatusLabel item={item} />}
                      </div>
                    </div>
                  ))}
                </>
              </div>
            </div>
          </div>
        </div> :
        <PostNotFound title={"No Post Found"} height={500} />

      }

    </>
  );
}
